export default {
  API_HOST: localStorage.getItem('api-host') || process.env.VUE_APP_API_HOST,
  CLOUD_HOST: process.env.VUE_APP_API_CLOUD,
  API_PORT: process.env.VUE_APP_API_PORT,
  API_VERSION: process.env.VUE_APP_API_VERSION,
  STORAGE_BASE: process.env.VUE_APP_STORAGE_BASE
};
